/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { sendGTMSignInEvent } from '@/data/events/handlers/gtm/SignIn';
import { GTMSignUpPayload } from '@/data/types/GTM';

type SignUpDelegatorProps = {
	gtm?: GTMSignUpPayload;
};

export const signUpDelegator = async (payload: SignUpDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMSignInEvent(gtm);
	}
};
